<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />

    <div v-if="featureStore.images.length === 0">
      <FeatureInitSection
        include-uploader
        include-bulk-introducer
        :feature="featureStore.feature"
        :intro-count="3"
        :sample-count="4"
      />
      <PageUpscaleAndEnhance />
    </div>

    <div v-else class="h-full">
      <LayoutDefault show-cost :total-cost="totalCost" @finished="onFinished">
        <template #aside>
          <form>
            <fieldset :disabled="featureStore.processing" class="flex flex-col space-y-6">
              <div class="flex flex-col space-y-2">
                <label for="upscale" class="input-label">Upscale</label>
                <div class="flex space-x-4 items-center">
                  <label
                    v-for="upscale in [
                      ['200%', 2],
                      ['400%', 4],
                    ]"
                    :key="upscale[1]"
                    class="w-1/2 input-label icon-option flex space-x-2 items-center justify-center"
                    :class="{ 'icon-option--pro': upscale[1] === 4 }"
                    :for="`upscale_${upscale[1]}`"
                  >
                    <input
                      :id="`upscale_${upscale[1]}`"
                      v-model="featureStore.options['upscale-and-enhance-image'].upscale"
                      class="radio"
                      :value="upscale[1]"
                      type="radio"
                    />
                    <span>{{ upscale[0] }}</span>
                  </label>
                </div>
              </div>
            </fieldset>
          </form>
        </template>
      </LayoutDefault>
    </div>
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import { useCostCalculate } from '$/composables/useCostCalculate'
  import PageUpscaleAndEnhance from '&/landing_pages/PageUpscaleAndEnhance.vue'
  import FeatureMeta from '&/FeatureMeta.vue'
  import { watch } from 'vue'

  const {
    ready,
    router,
    slug,
    featureStore,
    subscriptionStore,
    watchRestrictedOption,
    watchTaskOptions,
    LayoutDefault,
    FeatureInitSection,
  } = useFeatureSetup()
  const { totalCost } = useCostCalculate()

  function onFinished() {
    router.push({ name: 'UpscaleAndEnhanceResult' })
  }

  watchRestrictedOption(slug, 'upscale', 4, 'upscale_4x')
  watchTaskOptions()

  // If paid plan and select upscale 4x, auto select Full size
  watch(
    () => featureStore.options[slug].upscale,
    (newVal) => {
      if (newVal === 4 && subscriptionStore.isPaidUser) {
        setTimeout(() => {
          featureStore.taskOptions.size = 'full'
        }, 200)
      }
    },
    { immediate: true },
  )

  // If paid plan and select small size, auto select upscale 2x
  watch(
    () => featureStore.taskOptions.size,
    (newVal) => {
      if (newVal === 'small') {
        setTimeout(() => {
          featureStore.options[slug].upscale = 2
        }, 200)
      }
    },
    { immediate: true },
  )
</script>
